import { render, staticRenderFns } from "./AllowedBrandsList.vue?vue&type=template&id=6b6ce3f0&scoped=true&"
import script from "./AllowedBrandsList.vue?vue&type=script&lang=js&"
export * from "./AllowedBrandsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ce3f0",
  null
  
)

export default component.exports